import { render } from "./cpt-dataV-activeRing-option.vue?vue&type=template&id=0db3fee9"
import script from "./cpt-dataV-activeRing-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-activeRing-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__